import React from 'react';
import './ProblemStatement.css';

const ProblemStatement = () => {
  return (
    <section className="problem-statement">
      <div className="container">
        <div className="problem-header">
          <h2>The Traditional Card Collection Problem</h2>
          <p>Every expo, conference, and networking event faces the same challenges</p>
        </div>

        <div className="problem-visual">
          <div className="before-after-container">
            <div className="before-section">
              <h3>Traditional Method</h3>
              <div className="photo-grid">
                <div className="photo-item">
                  <img src="/assets/traditional-cards-bowl.png" alt="Business cards scattered in collection bowl" />
                  <div className="photo-overlay">
                    <p>Cards lost in collection bowls</p>
                  </div>
                </div>
                <div className="photo-item">
                  <img src="/assets/crowded-expo-hall.png" alt="Busy expo hall with traditional booths" />
                  <div className="photo-overlay">
                    <p>Crowded expo halls, missed connections</p>
                  </div>
                </div>
                <div className="photo-item">
                  <img src="/assets/manual-data-entry.png" alt="Person manually entering business card data" />
                  <div className="photo-overlay">
                    <p>Hours of manual data entry</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="solution-arrow">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14m-7-7l7 7-7 7" />
              </svg>
              <span>Transform Your Process</span>
            </div>

            <div className="after-section">
              <h3>Scan2Card Solution</h3>
              <div className="photo-grid">
                <div className="photo-item">
                  <img src="/assets/qr-code-scanning.png" alt="QR code scanning with smartphone" />
                  <div className="photo-overlay success">
                    <p>Instant QR code scanning</p>
                  </div>
                </div>
                <div className="photo-item">
                  <img src="/assets/digital-analytics.png" alt="Digital analytics dashboard" />
                  <div className="photo-overlay success">
                    <p>Real-time analytics & insights</p>
                  </div>
                </div>
                <div className="photo-item">
                  <img src="/assets/team-collaborating.png" alt="Professional networking at modern expo" />
                  <div className="photo-overlay success">
                    <p>Seamless team collaboration</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="problem-stats">
          <div className="stat">
            <div className="stat-number">73%</div>
            <div className="stat-label">of business cards are thrown away within a week</div>
          </div>
          <div className="stat">
            <div className="stat-number">2.5hrs</div>
            <div className="stat-label">average time spent manually entering card data</div>
          </div>
          <div className="stat">
            <div className="stat-number">40%</div>
            <div className="stat-label">of leads are never followed up due to poor organization</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemStatement;